var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.tableHeaders,"items":_vm.listLotesFiltrada,"loading":_vm.loading,"item-key":"idLoteProducao","calculate-widths":true,"dense":""},on:{"click:row":_vm.goToLote}})}
var staticRenderFns = []

export { render, staticRenderFns }